var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollapseMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 22,
    viewBox: "0 0 29 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 2624",
    width: 15,
    height: 4,
    rx: 2,
    transform: "translate(0 9)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 2625",
    width: 15,
    height: 4,
    rx: 2,
    transform: "translate(0 18)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 2626",
    width: 29,
    height: 4,
    rx: 2,
    style: {
      fill: "currentColor"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseMenu);
export default __webpack_public_path__ + "static/media/collapse_menu.e94c83fb484b9d42960b2c74d9e30acf.svg";
export { ForwardRef as ReactComponent };